module.exports = __webpack_public_path__ + "img/Logo.5928c550.svg";